import React, { useState } from "react";

import CatCreate from "./CatCreate";
import CatList from "./CatList";

const CatTab = () => {
  /* **********************************
   * GLOBAL STATE
   * 전역 상태 및 전역 변수
   ********************************** */

  /* **********************************
   * LOCAL STATE
   * 컴포넌트 내부에서 사용하는 상태
   ********************************** */
  
  const [useCurrentMode, setUseCurrentMode] = useState<"CREATE" | "LIST">("LIST");

    return (
      <>
        {useCurrentMode === "LIST" && <CatList goToCreateMode={() => setUseCurrentMode("CREATE")} />}
        {useCurrentMode === "CREATE" && <CatCreate goToListMode={() => setUseCurrentMode("LIST")} />}
      </>
    )
}

export default CatTab;